(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"] && !Shopify.designMode) return;
  try {
    
  function __slider_announcement() {
    const sliderNode = document.querySelector('#slider__announcement')
    const viewportNode = sliderNode.querySelector('.slider__viewport')
    const __slider__ = EmblaCarousel(viewportNode, { loop: true })

    function autoplay() {
      if (!__slider__) return
      __slider__.scrollNext()
      const speed = parseInt(
        document.querySelector('#slider__announcement').dataset.speed,
      )
      setTimeout(autoplay, speed)
    }

    autoplay()
  }

  __slider_announcement()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function () {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(
      '.product-recommendations',
    )
    if (productRecommendationsSection === null) {
      return
    }
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId
    // Read base URL from data attribute
    var baseUrl = productRecommendationsSection.dataset.baseUrl
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit
    // Build request URL
    var requestUrl =
      baseUrl +
      '?section_id=product-recommendations&product_id=' +
      productId +
      '&limit=' +
      limit
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest()
    request.open('GET', requestUrl)
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div')
        container.innerHTML = request.response
        productRecommendationsSection.parentElement.innerHTML =
          container.querySelector('.product-recommendations').innerHTML

        var cards = container.querySelectorAll(
          '.product-recommendations .product-card-slider',
        )

        for (const card of cards) {
          __slider(card.getAttribute('product-id'))
        }
      }
    }
    request.send()
  }
  // Listen for changes done in the Theme Editor
  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === 'product-recommendations') {
      loadProductRecommendationsIntoSection()
    }
  })
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection()

  } catch(e) { console.error(e); }
})();
})();
